
// AUTH
export const LOGIN_TOKEN_REFRESH_URL = "/api/token/refresh/";

// WEB BASE URL
// CMS
export const CMS_URLS = {
    cms: '/api/wb/cms/contents/', // + type
    faq: '/api/wb/cms/faq/',
}
// Home
export const HOME_URLS = {
    banners: '/api/wb/basic/banners/web/', // + type

}

// COURSE
export const COURSE_URLS = {
    list: '/api/wb/basic/courses/',
    get: '/api/wb/basic/course/', // +slug
}

export const GOOGLE_REVIEWS_URLS = {
    list: '/api/wb/basic/google-reviews/',
}

export const SUCCESS_STORIES_URLS = {
    list: '/api/wb/basic/success-stories/',
}

export const ACHIEVERS_URLS = {
    list: '/api/wb/basic/achievers/',
}

// Marquee announcements for the nav ribbon. The endpoint is not implemented on
// the backend yet; the ribbon falls back to demo items until it ships.
export const ANNOUNCEMENT_URLS = {
    list: '/api/wb/basic/announcements/',
}

// Contact form submissions (`add_ConnectForm`).
export const CONTACT_URLS = {
    add: '/api/wb/basic/contact/add/',
}

export const BLOG_URLS = {
    list: '/api/wb/basic/blogs/',
    get: '/api/wb/basic/blog/', // +slug
}

export const STUDENT_WALL_URLS = {
    list: '/api/wb/basic/achievers/',
}

// One request for everything the homepage renders, each section already capped
// server-side. See basic/views/web/basic_views.py::getHomeBundle.
export const HOME_BUNDLE_URLS = {
    list: '/api/wb/basic/home-bundle/',
}

export const TEAM_URLS = {
    list: '/api/wb/basic/team/',
}

export const SERVICE_URLS = {
    list: '/api/wb/basic/services/',
    get: '/api/wb/basic/service/', // +slug
}

// Account self-service (username + password re-authentication).
export const ACCOUNT_URLS = {
  delete: '/api/s/auth/account/del/',
};
